import React from "react";
import TableHeader from "../components/table-header";
import TableList from "../components/table-list";
import { CircularProgress } from "@mui/material";
import useFinanceInventory from "../data-handling/use-finance-inventory";

function MainView() {
  const { componentLoaders } = useFinanceInventory();

  return (
    <div className="font-inter w-full h-full bg-[rgb(242,243,247)] py-16 px-20">
      <div className="h-full flex flex-col bg-white rounded-[6px] relative">
        {componentLoaders.GENERAL && <div className="absolute top-0 right-0 left-0 bottom-0 bg-[#0000000f] flex justify-center items-center"><CircularProgress /></div>}
        <TableHeader />
        <div className="overflow-x-auto flex-1">
          <TableList />
        </div>
      </div>
    </div>
  );
}

export default MainView;
